import { render, staticRenderFns } from "./WidgetFooter.vue?vue&type=template&id=a6c36e2c&scoped=true&"
import script from "./WidgetFooter.vue?vue&type=script&lang=js&"
export * from "./WidgetFooter.vue?vue&type=script&lang=js&"
import style0 from "./WidgetFooter.vue?vue&type=style&index=0&id=a6c36e2c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c36e2c",
  null
  
)

export default component.exports